'use strict';

var _wendysI18next = require('wendys-i18next');

var _FlagSelector = require('./FlagSelector');

var _FlagSelector2 = _interopRequireDefault(_FlagSelector);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PropTypes = require('prop-types');
/**
 * Created by skoda02 on 10/28/16.
 */

var React = require('react');
var createReactClass = require('create-react-class');
var PageTitle = require('../pageTitle.js').default;
var UpdatePostalCodeComponent = require('./updatePostalCode.js');

module.exports = createReactClass({
    displayName: 'exports',

    propTypes: {
        handleBackClick: PropTypes.func.isRequired,
        isLoyaltyIntent: PropTypes.bool,
        removeMessageFromProps: PropTypes.func,
        socialSubmitHandler: PropTypes.func.isRequired,
        postalCode: PropTypes.string
    },
    getInitialState: function getInitialState() {
        this.currencyOptions = (0, _wendysI18next.getTranslatedString)('email_sign_up_currency_options');
        return {
            socialMedium: this.props.socialMedium || '',
            showFlagSelector: this.props.showFlagSelector,
            selectedLocale: { id: '' },
            flagUrl: '',
            selectedCurrency: '',
            dropDownOptions: []
        };
    },
    componentDidMount: function componentDidMount() {
        if (this.props.setBackAction) {
            this.props.setBackAction(this.handleBackClick);
        }
        document.querySelector('#page-title').focus();
    },
    onSubmit: function onSubmit(params) {
        if (this.props.socialSubmitHandler) {
            params.optIn = false;
            this.props.socialSubmitHandler(params);
        }
    },
    handleFlagSelection: function handleFlagSelection() {
        var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var showFlagSelector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        var selectedCurrency = locale.id ? (0, _find2.default)(this.currencyOptions, { id: locale.id }).value : '';
        this.setState({
            showFlagSelector: showFlagSelector,
            selectedLocale: locale,
            flagUrl: url,
            dropDownOptions: this.currencyOptions.map(function (obj) {
                return obj.value;
            }),
            selectedCurrency: selectedCurrency,
            currencyPostValue: this.returnCurrencyPostValue(selectedCurrency)
        });
    },
    changeSelectedCurrency: function changeSelectedCurrency(currencyChoice) {
        this.setState({
            selectedCurrency: currencyChoice,
            currencyPostValue: this.returnCurrencyPostValue(currencyChoice)
        });
    },
    returnCurrencyPostValue: function returnCurrencyPostValue(currencyChoice) {
        if (currencyChoice) {
            return (0, _find2.default)(this.currencyOptions, { value: currencyChoice }).postValue;
        }
    },
    handleBackClick: function handleBackClick() {
        if (this.state.selectedLocale.id) {
            this.handleFlagSelection({}, '', true);
        } else {
            this.props.handleBackClick();
        }
    },
    spliceError: function spliceError(idx) {
        if (this.props.removeErrorClick) {
            this.props.removeErrorClick(idx);
        }
    },
    removeMessageFromProps: function removeMessageFromProps(idx) {
        if (this.props.removeMessageFromProps) {
            this.props.removeMessageFromProps(idx);
        }
    },
    render: function render() {
        var that = this;
        var subTitle = (0, _wendysI18next.getTranslatedString)('email_sign_up_need_info');
        if (this.props.isLoyaltyIntent) {
            subTitle = (0, _wendysI18next.getTranslatedString)('email_sign_up_need_info_loyalty');
        }

        var errors = this.props.errors && this.props.errors.length > 0 ? React.createElement(
            'div',
            { ref: 'errorAlert', className: 'row' },
            React.createElement(
                'div',
                { className: 'col-xs-12 errors' },
                this.props.errors.map(function (error, idx) {
                    return React.createElement(
                        'p',
                        { className: 'bg-danger alert-danger alert' },
                        error,
                        React.createElement(
                            'span',
                            { onClick: that.spliceError.bind(that, idx), className: 'close', 'aria-hidden': 'true' },
                            '\xD7'
                        )
                    );
                })
            )
        ) : [];

        var messages = [];
        if (this.props.messages && this.props.messages.length) {
            this.props.messages.forEach(function (message, idx) {
                messages.push(React.createElement(
                    'p',
                    { key: "message-prop" + idx, className: 'bg-success alert-success alert' },
                    message,
                    React.createElement(
                        'span',
                        { className: 'close', onClick: that.removeMessageFromProps.bind(that, idx) },
                        '\xD7'
                    )
                ));
            });
        }

        return React.createElement(
            'div',
            null,
            React.createElement(
                'div',
                { className: 'sign-up-container social' },
                React.createElement(
                    'div',
                    { className: 'container' },
                    this.state.showFlagSelector ? React.createElement(_FlagSelector2.default, { handleFlagSelection: this.handleFlagSelection }) : React.createElement(
                        'div',
                        {
                            className: 'col-xs-12 col-sm-6 col-sm-offset-3 col-md-5 col-md-offset-4 col-lg-4 col-lg-offset-4' },
                        React.createElement(PageTitle, { titleText: (0, _wendysI18next.getTranslatedString)('email_sign_up_page_title') }),
                        React.createElement(
                            'div',
                            { 'aria-live': 'polite' },
                            errors,
                            messages
                        ),
                        React.createElement(UpdatePostalCodeComponent, {
                            handleSubmit: this.onSubmit,
                            submitButtonText: (0, _wendysI18next.getTranslatedString)("email_sign_up"),
                            postalCode: this.props.postalCode,
                            requireTerms: true,
                            subTitle: subTitle,
                            currencyOptions: this.state.dropDownOptions,
                            selectedCurrency: this.state.selectedCurrency,
                            changeSelectedCurrency: this.changeSelectedCurrency,
                            selectedLocale: this.state.selectedLocale,
                            flagUrl: this.state.flagUrl,
                            currencyPostValue: this.state.currencyPostValue,
                            shouldShowLocalizationFlow: this.props.showFlagSelector
                        })
                    )
                )
            )
        );
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/loginComponents/socialSignUp.js
// module id = 730
// module chunks = 0